import coreApiClient from "@/providers/core-api/CoreApi"
const resourceName = "/v1/conversations"

export default {
  get(id) {
    return coreApiClient.sendRequest("get", `${resourceName}/${id}`, {})
  }
}
